import { createContext, useContext } from "react";

/**
 * Shared selected bid index so OfferAttractiveness can focus amount/payback-time
 * fields on the tab the user is viewing (combo offers). BidsForm updates it on
 * tab change; OfferAttractiveness reads it to build the correct field path.
 */
interface SelectedBidIndexContextValue {
  selectedBidIndex: number;
  setSelectedBidIndex: (index: number) => void;
}

export const SelectedBidIndexContext =
  createContext<SelectedBidIndexContextValue | null>(null);

/** Returns the currently selected bid index */
export function useSelectedBidIndex(): number {
  const ctx = useContext(SelectedBidIndexContext);

  return ctx?.selectedBidIndex ?? 0;
}
